import { homeStateSelector } from "@store/redux/modules/home";
import { useSelector } from "react-redux";
import MoonSvg from "@assets/icons/moon.svg?react";
import { useTranslation } from "react-i18next";
const Sunrise: React.FC<any> = ({ forecast1day = undefined, current = undefined }) => {
  const homeState = useSelector(homeStateSelector);
  forecast1day = (forecast1day || homeState?.["forecast1day"]) ?? {};
  current = (current || homeState?.["current"]) ?? {};
  const { t: $t } = useTranslation();
  return (
    <WeatherMainContent className="content flex flex-col gap-y-16">
      <div className="w-full flex justify-between items-center">
        <div className="flex items-center gap-x-16">
          <label className="font-weight-300 font-size-12 color-[rgba(255,255,255,0.7)]">{$t("title12")}</label>
          {/* <b>{forecast1day?.[current.IsDayTime*1 === 1 ? "Sun" : "Moon"]?.Rise}</b> */}
          <b className="font-400 text-16">{forecast1day?.["Sun"]?.Rise}</b>
        </div>
        <div className="flex items-center gap-x-16">
          <label className="font-weight-300 font-size-12 color-[rgba(255,255,255,0.7)]">{$t("title13")}</label>
          {/* <b>{forecast1day?.[current.IsDayTime*1 === 1 ? "Sun" : "Moon"]?.Set}</b> */}
          <b className="font-400 text-16">{forecast1day?.["Sun"]?.Set}</b>
        </div>
      </div>

      <div className="flex items-center gap-x-4 w-full">
        <div
          className="h-8 bg-[rgba(255,255,255,0.5)] rounded-15"
          style={{ width: `${forecast1day?.[current?.IsDayTime * 1 === 1 ? "Sun" : "Moon"]?.rate}%` }}
        ></div>
        <div className="icon">{current?.IsDayTime * 1 === 1 ? <SvgIcon name="sun" size={20} /> : <MoonSvg />}</div>
        <div
          className="h-8 bg-[rgba(255,255,255,1)] rounded-15"
          style={{ width: `${100 - forecast1day?.[current?.IsDayTime * 1 === 1 ? "Sun" : "Moon"]?.rate}%` }}
        ></div>
      </div>

      <div className="w-full flex justify-between items-center">
        <div>
          {$t("title14")} {forecast1day?.["Moon"]?.Rise}
        </div>
        <div className="relative pr-16">
          {$t("title15")} {forecast1day?.["Moon"]?.Set}{" "}
          <sub className="absolute font-szie-10 bottom-0 right-0">
            {forecast1day?.Moon?.NextDay > 0 ? "+" + forecast1day.Moon.NextDay : ""}
          </sub>
        </div>
      </div>
    </WeatherMainContent>
  );
};
export default Sunrise;
